import { Injectable, OnInit } from '@angular/core';
import { UserService } from 'app/shared/services/user/user.service';
import { Session } from 'app/shared/services/session/session.service';
import { ActiveUser } from 'app/shared/services/user/active-user.model';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class WalkthroughService {
  user: ActiveUser;
  debugMode: boolean = false; // flip to true to prevent saving to user while creating a new walkthrough

  walkthroughs: any = {
    imageLibrary: {
      initialized: false,
      nextStep: new Subject<any>(),
      currentStep: 0,
      totalSteps: 6
    },
    calendarMoved: {
      initialized: false,
      nextStep: new Subject<any>(),
      currentStep: 0,
      totalSteps: 4
    },
    editCalendar: {
      initialized: false,
      nextStep: new Subject<any>(),
      currentStep: 0,
      totalSteps: 2
    }
  };

  constructor(private session: Session,
              private userService: UserService) {
    this.session.user()
    .then((user) => {
      this.user = user;
    });
  }

  initializeWalkthrough(name: string, startWith?: number) {
    let walkthrough = this.walkthroughs[name];
    if (startWith) walkthrough.currentStep = startWith - 1;
    if (!walkthrough) {
      console.error('No walkthrough found named ' + name);
      return;
    }

    if (!walkthrough.initialized) {
      walkthrough.initialized = true;
      document.body.classList.add('has-walkthrough');

      // if this walkthrough name is not on the user, it hasn't been viewed yet
      if (this.willDisplayWalkthrough(name)) {
        this.nextStep(name);

        // if it is there, end this walkthrough
      } else {
        this.endWalkthrough(name);
      }
    }
  }

  willDisplayWalkthrough(walkthroughName: string) {
    return this.user.viewedWalkthroughs.indexOf(walkthroughName) === -1 || this.debugMode;
  }

  nextStep(name: string) {
    let walkthrough = this.walkthroughs[name];
    walkthrough.currentStep++;

    if (walkthrough.currentStep > walkthrough.totalSteps) {
      // if we've surpassed the end, let the tooltips know we're done
      this.endWalkthrough(name);

    } else {
      // otherwise keep on going
      walkthrough.nextStep.next(walkthrough.currentStep);
    }
  }

  // re-emits the current step for a given walkthrough
  resumeStep(name: string) {
    let walkthrough = this.walkthroughs[name];
    walkthrough.nextStep.next(walkthrough.currentStep);
  }

  forceStep(name: string, step: number) {
    let walkthrough = this.walkthroughs[name];
    walkthrough.currentStep = step;
    walkthrough.nextStep.next(step);
  }

  endWalkthrough(name: string) {
    this.walkthroughs[name].currentStep = -1;
    this.walkthroughs[name].nextStep.next(-1);
    document.body.classList.remove('has-walkthrough');

    // update in-memory user to let them know they've now seen this walkthrough
    if (this.user.viewedWalkthroughs.indexOf(name) == -1 && !this.debugMode) {
      this.user.viewedWalkthroughs.push(name);
      // console.log('REMOVE TEMP WALKTHROUGH NULLS BELOW THIS LINE');
      // this.user.viewedWalkthroughs = ['none'];
      return this.userService.updateUserRemoteCache(this.user.id, { viewed_walkthroughs: this.user.viewedWalkthroughs });
    } else if (this.debugMode) {
      console.log('Turn off debug mode in walkthrough.service');
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/services/walkthrough/walkthrough.service.ts